import { ErrorLogsCompassApi } from '@/../generated-client/apis/ErrorLogsCompassApi';
import { useApiStore } from '@/stores/apiStore';

let errorLogsCompassApi: ErrorLogsCompassApi | null = null;
let lastConfig: unknown = null;

function getErrorLogsCompassApi(): ErrorLogsCompassApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (errorLogsCompassApi === null || lastConfig !== apiConfig) {
    errorLogsCompassApi = new ErrorLogsCompassApi(apiConfig);
    lastConfig = apiConfig;
  }

  return errorLogsCompassApi;
}
export const getAllErrorLogs = async (compassVersion: string) => {
  const api = getErrorLogsCompassApi();

  return await api.apiErrorLogsCompassGetAllByVersionGet({
    firmwareVersion: compassVersion,
  });
};
